import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./home.css";
import linkedin from "../Nav/icono link.png";
import git from "../Nav/icono git.png";

const TEXTS = {
  es: {
    name: "Víctor Barreto",
    headline: "Construyo productos web que se ven bien, cargan rápido y convierten.",
    sub: "Desarrollador Full-Stack · React + Node.js · UX + Performance",
    ctaProjects: "Ver proyectos",
    ctaContact: "Contactarme",
    quick: "Atajos",
  },
  en: {
    name: "Victor Barreto",
    headline: "I build web products that look great, load fast, and convert.",
    sub: "Full-Stack Developer · React + Node.js · UX + Performance",
    ctaProjects: "View projects",
    ctaContact: "Contact me",
    quick: "Quick links",
  },
};

export default function Home() {
  const [lang, setLang] = useState("es");
  const t = TEXTS[lang];

  return (
    <div className="home-wrap">
      <section className="home-hero card">
        {/* Toggle ES/EN */}
        <div className="home-lang">
          <button
            className={`lang-btn ${lang === "es" ? "active" : ""}`}
            onClick={() => setLang("es")}
          >
            ES
          </button>
          <button
            className={`lang-btn ${lang === "en" ? "active" : ""}`}
            onClick={() => setLang("en")}
          >
            EN
          </button>
        </div>

        <div className="home-badges">
          <span className="badge">Full-Stack</span>
          <span className="badge">React</span>
          <span className="badge">Node.js</span>
          <span className="badge">UX</span>
        </div>

        <h1 className="home-title">{t.name}</h1>
        <p className="home-headline">{t.headline}</p>
        <p className="home-sub">{t.sub}</p>

        <div className="home-actions">
          <Link to="/proyectos" className="btn btn-primary">
            {t.ctaProjects}
          </Link>
          <Link to="/contacto" className="btn">
            {t.ctaContact}
          </Link>
        </div>

        <div className="home-divider" />

        <div className="home-bottom">
          <div className="home-quick">
            <span className="home-quick-title">{t.quick}</span>
            <div className="home-links">
              <Link to="/sobre-mi" className="home-link">Sobre mí</Link>
              <Link to="/cv" className="home-link">CV</Link>
              <Link to="/proyectos" className="home-link">Proyectos</Link>
              <Link to="/contacto" className="home-link">Contacto</Link>
            </div>
          </div>

          <div className="home-socials">
            <a
              className="home-social"
              href="https://www.linkedin.com/in/v%C3%ADctor-barreto-486487255/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedin} alt="" />
              <span>LinkedIn</span>
            </a>
            <a
              className="home-social"
              href="https://github.com/vapretito"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={git} alt="" />
              <span>GitHub</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
